import React, { useEffect } from 'react';
import ObjectsReestrView from '../components/contents/ObjectsReestrView';
import FieldWorksView from '../components/contents/FieldWorksView';

const FieldWorksPage = () => {

  useEffect(() => {
    document.title = "Записи полевых работ";
}, []);

  return (
    <FieldWorksView />
  );
};

export default FieldWorksPage; 